import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";


const swiperSlider = () => {
  //   const swiper = new Swiper(".swiper", {
  //     direction: "vertical",
  //     loop: true,
  //     // If we need pagination
  //     pagination: {
  //       el: ".swiper-pagination",
  //     },
  //     // Navigation arrows
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     // And if we need scrollbar
  //     scrollbar: {
  //       el: ".swiper-scrollbar",
  //     },
  //     modules: [Navigation, Pagination, Scrollbar],
  //   });

  const swiperSlider = new Swiper(".swiper_gallery", {
    slidesPerView: 1.3,
    loop: false,
    spaceBetween: 15,
    modules: [Navigation, Autoplay],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      990: {
        slidesPerView: 3
      }
    }
  });

};

export default swiperSlider